export const premiumTableComment = () => {
    document.addEventListener('click', async function (event) {
        const target = event.target;
        if (!target.matches('.comment_td')) return;
        event.preventDefault();

        const {default:swal} = await import('sweetalert2');
        swal.fire({
            title: target.innerText,
            icon: 'info',
            confirmButtonText: 'Ok'
        })


    }, false);
}
